"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// import { PACKAGES_LOADED } from "../packages/packagesConstants";


exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  // if (action.type === PACKAGES_LOADED) {
  //   return {
  //     ...state,
  //     packages: {
  //       ...state.packages,
  //       []
  //     }
  //   }
  // }
  if (action.type === _configConstants.CONFIG_LOADED) {
    return _extends({}, state, {
      prefix: action.configData.docker.prefix,
      // pushPrefix defaults to regular prefix if not provided
      pushPrefix: action.configData.docker.pushPrefix || action.configData.docker.prefix
    });
  }

  if (action.type === _fileConstants.FILE_LOADED && action.name === "Dockerfile") {
    var lines = _dockerFileParser2.default.parse(action.content);
    var from = void 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var line = _step.value;

        if (line.name === "FROM") {
          from = line.args;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return _extends({}, state, {
      packages: _extends({}, state.packages, _defineProperty({}, action.package, { from: from }))
    });
  }

  return state;
};

var _fileConstants = require("../file/fileConstants");

var _configConstants = require("../config/configConstants");

var _dockerFileParser = require("docker-file-parser");

var _dockerFileParser2 = _interopRequireDefault(_dockerFileParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  packages: {}
};
//# sourceMappingURL=dockerReducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/docker/dockerReducer.js
// module id = 246
// module chunks = 0